import React from 'react'

const ContainerResource = (props) => {
  const { resource,handleDragStart } = props
  return (
    <div draggable onDragStart={e => handleDragStart(e, "Resource",resource)}>{resource.resourceNo}</div>
  )
}

export default ContainerResource